module.exports = __webpack_public_path__ + "static/media/fries.e727c2cf.webp";